// get createStore from redux to create a store for all application redux store
import { createStore } from 'redux'
//getting rootReducer from ./reducers for all the reducers added in root reducer
import rootReducer from './reducers'
/**
 * On createStore passing rootReducer or access added to redux devtools
 */
const Store = createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
export default Store
